import { render, staticRenderFns } from "./nav-item.vue?vue&type=template&id=b287ec2c"
import script from "./nav-item.vue?vue&type=script&lang=js"
export * from "./nav-item.vue?vue&type=script&lang=js"
import style0 from "./nav-item.vue?vue&type=style&index=0&id=b287ec2c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports